import React, { useState } from "react";
import { PrimaryButton } from "../../atoms/Buttons";

import loadIcon from "../../../assets/images/tail-spin.svg";

import { P } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";
import { DELETE_CASE_SCHEDULE_MUTATION } from "../../../shared/queries";
import { useMutation } from "@apollo/client";
import { toastError } from "../../../shared/helpers";

const DeleteCaseScheduleModal = ({ closeModal, schedule }) => {
  const [deleting, setDeleting] = useState(false);

  const [deleteSchedule] = useMutation(DELETE_CASE_SCHEDULE_MUTATION);

  const onDeleteSchedule = () => {
    setDeleting(true);

    deleteSchedule({
      variables: {
        caseScheduleId: schedule.id,
        organizationId: schedule.orgId,
      },
    })
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        toastError(error.message);
      });
  };
  return (
    <ModalHolder closeModal={closeModal} header="Delete Schedule">
      <section className="py-4 md:py-6">
        <P className="mb-4">
          Deleting this schedule is irreversible, are you certain of this action?
        </P>
        <PrimaryButton.Danger disabled={deleting} onClick={onDeleteSchedule}>
          {!deleting ? (
            "Delete Schedule"
          ) : (
            <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
          )}
        </PrimaryButton.Danger>
      </section>
    </ModalHolder>
  );
};

export default DeleteCaseScheduleModal;
